module.exports = __webpack_public_path__ + "static/img/audio.87bc0289.png";